import React from 'react';
import ReactDOM from 'react-dom';

import { render } from '@mairistem/module';
import AppComptabilite from './AppComptabilite';

import '@mairistem/comptabilite/lib/comptabilite.css';
import '@mairistem/finances-utils/lib/finances-utils.css';
import '@mairistem/composants/lib/composants.css';
import '@mairistem/piecesjointes/lib/piecesjointes.css';
import 'rsuite-table/lib/less/index.less';
import { initialize } from './sentry';

const code = '360_EXE';

// Ne pas modifier ou supprimer
// Utile en mode production afin que le style se place au bon endroit
if (process.env.NODE_ENV !== 'development') {
  const oldCreatePortal = ReactDOM.createPortal;

  // @ts-ignore
  ReactDOM.createPortal = (child, domNode) => oldCreatePortal(
    child,
    domNode === document.body
      ? document.querySelector(`#${CSS.escape(code)}`) || domNode
      : domNode || document.querySelector(`#${CSS.escape(code)}`),
  );
}

initialize();

render(<AppComptabilite />);
